import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PrimaryButton, NamedLink } from '../../components';

import css from './FAQSectionFooter.module.css';

const FAQSectionFooter = () => {
  return (
    <div className={css.root}>
      <h1>
        <FormattedMessage id="FAQLandownersPage.footer.title" />
      </h1>

      <p className={css.content}>
        <FormattedMessage id="FAQLandownersPage.footer.body" />
      </p>

      <PrimaryButton component={NamedLink} name="NewListingPage">
        <FormattedMessage id="FAQLandownersPage.howItWorks.cta" />
      </PrimaryButton>
    </div>
  );
};

export default FAQSectionFooter;
